import Table from 'components/commons/table'
import { TABLE_REVIEW } from 'configs/user/user-detail/configTableReview'
import { Button, Modal } from 'avo-ui'
import icX from 'assets/images/ic-x.svg'
import { innerHTML } from 'utils/utils'

export const TabReview = ({
    dataList,
    query,
    onChangeQuery,
    showReview,
    detailReview,
    onHideReview,
    showReviewHandler,
    isLoading,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <Table
                className={'my-3'}
                name={TABLE_REVIEW.name}
                columns={TABLE_REVIEW.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onClickItem={(value) => showReviewHandler(value)}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
            {showReview && (
                <Modal
                    dialogClassName={'w-[500px]'}
                    contentClassName={'rounded-xl'}
                    show={showReview}
                    onHide={onHideReview}
                >
                    <div className={'flex flex-row px-6 py-5 items-center justify-between'}>
                        <div />
                        <p className={'font-bold text-blue-90 text-lg mt-2'}>Review Detail</p>
                        <img className={'w-5 -mt-8 cursor-pointer'} src={icX} alt='ic-x' onClick={onHideReview} />
                    </div>
                    <div className={'h-[250px] overflow-auto px-4'} dangerouslySetInnerHTML={innerHTML(detailReview)} />
                    <div className={'px-6 py-3 flex justify-center'}>
                        <Button className={'w-[200px]'} title={'Close'} onClick={onHideReview} />
                    </div>
                </Modal>
            )}
        </div>
    )
}
